module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n    Create a new xinc project here!  \n  ")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitProject($event)
      }
    }
  }, [_c('p', [_vm._v("Your Role:")]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.role),
      expression: "project.role"
    }],
    attrs: {
      "type": "radio",
      "id": "project_role_client",
      "value": "client"
    },
    domProps: {
      "checked": _vm._q(_vm.project.role, "client")
    },
    on: {
      "__c": function($event) {
        _vm.project.role = "client"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "project_role_client"
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.role),
      expression: "project.role"
    }],
    attrs: {
      "type": "radio",
      "id": "project_role_contractor",
      "value": "contractor"
    },
    domProps: {
      "checked": _vm._q(_vm.project.role, "contractor")
    },
    on: {
      "__c": function($event) {
        _vm.project.role = "contractor"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "project_role_contractor"
    }
  }, [_vm._v("Contractor")])]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": "project_title"
    }
  }, [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.title),
      expression: "project.title"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "project_title",
      "type": "text"
    },
    domProps: {
      "value": (_vm.project.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.project.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('label', {
    attrs: {
      "for": "project_recipient"
    }
  }, [_vm._v("Recipient")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.recipient),
      expression: "project.recipient"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "project_recipient ",
      "type": "email"
    },
    domProps: {
      "value": (_vm.project.recipient)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.project.recipient = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.project.message),
      expression: "project.message"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "",
      "cols": "30",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.project.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.project.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("submit")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3e1aa8b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Create.vue
// module id = 126
// module chunks = 1